import React, { FC } from 'react';
import { Container as BaseContainer } from '@material-ui/core';

import { CONTAINER_MAX_WIDTH } from './props/containerProps';

interface ContainerProps {
  maxWidth?: CONTAINER_MAX_WIDTH;
}

const Container: FC<ContainerProps> = (props) => {
  return (
    <BaseContainer maxWidth={props.maxWidth}>
      <>{props.children}</>
    </BaseContainer>
  );
};

export default Container;
